import { React } from 'react';
import { Box, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from 'react-i18next';

const Author = ({ date }) => {
  const { i18n } = useTranslation("common");

  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return (
    <Box display={"flex"} width={"100%"}>
      <Box component={ListItem} disableGutters width={"auto"}>
        <ListItemText
          secondary={new Date(date).toLocaleDateString(i18n.language, options)}
          sx={{ textTransform: "capitalize" }}
        />
      </Box>
    </Box>
  );
}

export default Author;
